"use strict";
exports.__esModule = true;
exports.DOCUMENT_VERIFICATION_RESUBMIT = exports.DOCUMENT_VERIFICATION = void 0;
exports.DOCUMENT_VERIFICATION = {
    HEADER: 'Verify your identity',
    BODY: 'Your Flex offer is almost ready! Just verify your identity to get approved for a credit line. The verification process will ask you to provide a photo of your ID and take a selfie.',
    DISCLAIMER: 'Verification must be completed within 24 hours for your application to be processed',
    CTA: 'Continue'
};
exports.DOCUMENT_VERIFICATION_RESUBMIT = {
    HEADER: 'Something went wrong',
    BODY: 'Please try again to get approved for a credit line',
    CTA: 'Continue'
};
